import { RouteRecordRaw } from 'vue-router';
import { layoutAreaTypes } from '@/types/layoutTypes';

const repoAreaRoutes: Array<RouteRecordRaw> = [
  {
    path: '/ThemeViewer',
    name: 'Theme Viewer',
    redirect: '/ThemeViewer/Index',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/components/repoArea/RepoAreaLayout.vue'),
    meta: { layout: layoutAreaTypes.User },
    children: [
      {
        path: 'Index',
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/SnippetsHtmlPage.vue'),
      },
      {
        path: 'Buttons',
        name: 'Theme Viewer - Buttons',
        meta: { subtitle: 'Buttons' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/ButtonsRepositoryPage.vue'),
      },
      {
        path: 'Icons',
        name: 'Theme Viewer - Icons',
        meta: { subtitle: 'Icons' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/IconsRepositoryPage.vue'),
      },
      {
        path: 'PeoplePicker',
        name: 'Theme Viewer - People Picker',
        meta: { subtitle: 'People Picker' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/PeoplePickerRepositoryPage.vue'),
      },
      {
        path: 'Badges',
        name: 'Theme Viewer - Badges',
        meta: { subtitle: 'Badges' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/BadgesRepositoryPage.vue'),
      },
      {
        path: 'Tags',
        name: 'Theme Viewer - Tags',
        meta: { subtitle: 'Tags' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/TagsRepositoryPage.vue'),
      },
      {
        path: 'Dropdowns',
        name: 'Theme Viewer - Dropdowns',
        meta: { subtitle: 'Dropdowns' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/DropdownsRepositoryPage.vue'),
      },
      {
        path: '3D',
        name: 'Theme Viewer - 3D',
        meta: { subtitle: '3D' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/ThreeDRepositoryPage.vue'),
      },
      {
        path: 'Grids',
        name: 'Theme Viewer - Grids',
        meta: { subtitle: 'Grids' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/GridsRepositoryPage.vue'),
      },
      {
        path: 'Colors',
        name: 'Theme Viewer - Colors',
        meta: { subtitle: 'Colors' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/ColorsRepositoryPage.vue'),
      },
      {
        path: 'Snippets',
        name: 'Theme Viewer - Snippets',
        meta: { subtitle: 'Snippets' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/SnippetsHtmlPage.vue'),
      },
      {
        path: 'Faq',
        name: 'Theme Viewer - FAQ Page',
        meta: { subtitle: 'Snippets' },
        component: () => import(/* webpackChunkName: "home" */ '@/views/repoArea/FaqRepoPage.vue'),
      },
      {
        path: 'Gridmvp',
        name: 'Grid Mvp',
        meta: { subtitle: 'Grids Mvp' },
        component: () =>
          import(/* webpackChunkName: "home" */ '@/views/repoArea/gridMvp/GridMvp.vue'),
      },
    ],
  },
];

export default repoAreaRoutes;
